import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Golden Eagle letterhead matching the official Authorization document template.
 * Default: brand left + document title right (same as uploaded A4 header template).
 */
function GetsBrandHeader({ title, subtitle, variant = 'split' }) {
  if (variant === 'banner') {
    return (
      <Box sx={{ mb: 2 }}>
        <Box
          component="img"
          src="/gets/header-banner.png"
          alt="Golden Eagle Technical Solutions"
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
            border: '1px solid',
            borderColor: 'text.primary',
            bgcolor: '#fff'
          }}
        />
        {(title || subtitle) && (
          <Box sx={{ mt: 1.25, textAlign: 'center' }}>
            {title && (
              <Typography
                sx={{
                  fontFamily: '"Times New Roman", Times, serif',
                  fontWeight: 700,
                  fontSize: { xs: '0.95rem', sm: '1.15rem' },
                  textTransform: 'uppercase',
                  letterSpacing: 0.4,
                  lineHeight: 1.25
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: 'block' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          border: '2px double',
          borderColor: 'text.primary',
          minHeight: 64,
          bgcolor: '#fff'
        }}
      >
        <Box
          sx={{
            width: { xs: 150, sm: 220 },
            borderRight: '1px solid #888',
            display: 'flex',
            alignItems: 'center',
            px: 1.25,
            py: 0.75,
            overflow: 'hidden',
            bgcolor: '#fff'
          }}
        >
          <Box
            component="img"
            src="/gets/header-brand-left.png"
            alt="Golden Eagle Technical Solutions"
            sx={{ display: 'block', width: '100%', height: 'auto' }}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
            py: 1,
            textAlign: 'center'
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Times New Roman", Times, serif',
              fontWeight: 700,
              fontSize: { xs: '0.9rem', sm: '1.15rem' },
              textTransform: 'uppercase',
              letterSpacing: 0.4,
              lineHeight: 1.2
            }}
          >
            {title || 'Certification Authorization'}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.35 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default GetsBrandHeader;
